import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { MdAdd, MdOutlineSync } from "react-icons/md"

import { toast } from "react-toastify";
import { Button, Col, Row, Spinner } from "react-bootstrap"
import { Modal } from "../../../../../components/modal";
import { PlansTable } from "../../../components/table-plans"
import { NewEditPlan } from "./new-edit-plan";

import { getPlans, removePlan, updatePlan } from "../../../../../services/manager/signature.service";

import { ICommonTestComponent } from "../../../../../models/ICommonTestComponent";

export const Plans: React.FC<ICommonTestComponent> = ({ testMode = false, jestFunc = () => {} }) => {
  const { t: translation } = useTranslation();

  //Pagination
  // const [totalItens, setTotalItens] = useState(0)
  const [currentPage] = useState(1)

  //Ordering
  const [sortOrder, setSortOrder] = useState(1);
  const [sortField, setSortField] = useState("name");

  const [plansList, setPlansList] = useState([]);
  const [plan, setPlan] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const [showRemovePlanNotice, setShowRemovePlanNotice] = useState<boolean>(false);
  const [showNewEditPlan, setShowNewEditPlan] = useState<boolean>(false);

  const plansTableConfig = [
    {field: 'is_active', header: '', statusTemplate: true, sortable: false, style: {textAlign: 'center', width: '5%'}},
    {field: 'name', header: 'Título', sortable: true, style: {textAlign: 'center'}},
    {field: 'origin_title', header: 'Origem', sortable: true, style: {textAlign: 'center'}},
    {field: 'materials_max', header: 'Limite de disciplinas', sortable: true, style: {textAlign: 'center'}}, 
    {field: 'parcel', header: 'Valor da parcela', parcelTemplate: true, sortable: true, style: {textAlign: 'center'}},
    {field: 'actions', header: '', actionsTemplate: true, sortable: false, style: {textAlign: 'center', width: '7%'}},
  ]

  const handleTableSort = (event: any) => {
    let order = event.sortOrder > 0 ? event.sortField : '-' + event.sortField;
    
    setSortOrder(event.sortOrder);
    setSortField(event.sortField);

    getPlansList(`page=${currentPage}&ordering=${order}`)
};

  const handleSyncPlans = () => {
    jestFunc('sync-button')
  }

  const handleEditPlan = (_plan: any) => {
    setPlan(_plan);
    setShowNewEditPlan(true);
  }

  const handleChangeStatusPlan = (id: number, status: string) => {
    let obj = {
      is_active: status === 'active' ? true : false,
    }

    updatePlan(id, obj).then(() => {
      toast.success(`Plano ${status === 'active' ? "ativado" : "inativado"} com sucesso!`)
      getPlansList();
    })
  }

  const handleRemovePlan = (_plan: any) => {
    setPlan(_plan);
    setShowRemovePlanNotice(true);
  }

  const onSubmitRemovePlan = () => {
    setLoadingModal(true)
    removePlan(plan.id).then(() => {
      toast.success("Plano removido com sucesso!")
      setPlan(null)
      getPlansList();
    }).catch((err) => {
      console.log(err)
    }).finally(() => {
      setShowRemovePlanNotice(false);
      setLoadingModal(false)
    })
}

  const getPlansList = (_query?: string) => {
    getPlans(_query).then((plans: any) => {
      setPlansList(plans)
    }).finally(() => {
      setLoading(false)
    })
  }

  useEffect(() => {
    getPlansList();
  }, [])

  useEffect(() => {
    getPlansList();
    if (showNewEditPlan === false && plan) {
      setPlan(null)
    }
  }, [showNewEditPlan])

  if (loading && !testMode) {
    return (
      <div className="loading-container">
        <Spinner animation="border" variant="primary" />
      </div>
    )
  }
  
  if (showNewEditPlan) {
    return (
      <NewEditPlan back={setShowNewEditPlan} plan={plan}/>
    )
  }

  return (
    <Row className="ml-2 mt-3 mr-4">
      <Col md={6} className="mt-3">
        <h5 className="text-black mb-4"><b>Planos</b></h5>
      </Col>
      <Col md={6} className="text-end mb-2 mt-3">
        <Button className="mr-2" data-testid="new-button" onClick={() => {setShowNewEditPlan(true); jestFunc('new-button')}}>Novo Plano <MdAdd/></Button>
        <Button variant="outline-primary" data-testid="sync-button" onClick={() => handleSyncPlans()}>Sincronizar <MdOutlineSync/></Button>
      </Col>
      <Col xs={12}>
        <p className="font-light text-darker-grey">Configure abaixo os planos da DStore.</p>
      </Col>
      <Col xs={12}>
        <PlansTable
          treeFields={plansTableConfig}
          nodes={plansList}
          sortField={sortField} 
          sortOrder={sortOrder}
          handleTableSort={handleTableSort}
          handleEditPlan={handleEditPlan}
          handleRemovePlan={handleRemovePlan}
          handleChangeStatusPlan={handleChangeStatusPlan}
        />
      </Col>

      <Modal 
        headerTitle="Aviso" 
        submitButtonText={translation('manager.links.remove')}
        show={showRemovePlanNotice} 
        onHide={() => setShowRemovePlanNotice(false)} 
        onSubmit={onSubmitRemovePlan} 
        variant="confirm-modal"
        loading={loadingModal}
      >
        <>
          <p>
            Tem certeza que deseja excluir o plano <b>{plan?.name}</b>?
          </p>
        </>
      </Modal>
    </Row>
  )
}